var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-2 mt-md-0", class: { "chips-col": !_vm.disabled } },
    [
      _c(
        "div",
        { staticClass: "chips-container" },
        _vm._l(_vm.items, function(item, index) {
          return _c("div", { key: index, staticClass: "chip" }, [
            _c("span", [
              _c("span", { staticClass: "chip-field font-weight-bold" }, [
                _vm._v(" " + _vm._s(item.name) + " ")
              ])
            ]),
            !_vm.disabled
              ? _c(
                  "a",
                  {
                    staticClass: "pointer",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.remove(item)
                      }
                    }
                  },
                  [
                    _c("em", {
                      staticClass: "far fa-lg fa-times-circle chip-close-icon"
                    })
                  ]
                )
              : _vm._e()
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }